import { mutate } from 'swr';

import { FetcherParams } from '@/data/fetcher';

import { apiRunsPath, apiSessionsPath } from '../../utils/constants';
import { DeleteModal } from '../Delete';
import { ExampleCrudPane } from '../ExampleCrudPane/ExampleCrudPane';
import { useRunListActions } from './useRunListActions';

export function RunListActions(props: {
  control: ReturnType<typeof useRunListActions>[0];
  onAddToDatasetSuccess?: () => void;
}) {
  return (
    <>
      {props.control.deleteOpen != null && (
        <DeleteModal
          endpoint={apiRunsPath}
          id={props.control.deleteOpen}
          isOpen={!!props.control.deleteOpen}
          doClose={() => props.control.setDeleteOpen(null)}
          invalidationPrefixes={[apiSessionsPath]}
        />
      )}
      {props.control.exampleOpen != null && (
        <ExampleCrudPane
          key={props.control.exampleOpen?.id}
          run={props.control.exampleOpen}
          isOpen={!!props.control.exampleOpen}
          doClose={() => props.control.setExampleOpen(null)}
          onSuccess={() => {
            mutate((key: FetcherParams) => key?.url?.startsWith(apiRunsPath));
            props.onAddToDatasetSuccess?.();
          }}
        />
      )}
    </>
  );
}
